export default {
  email: null,
  name: null,
  username: null,
  avatarLink: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/account/state.js